export default __webpack_public_path__ + "icon2af5cde.png";